import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SiteLayout from "@/components/layout/SiteLayout";
import SeoManager from "@/components/seo/SeoManager";
import AboutPage from "@/pages/AboutPage";
import ClientsPage from "@/pages/ClientsPage";
import ContactPage from "@/pages/ContactPage";
import HomePage from "@/pages/HomePage";
import IndustriesPage from "@/pages/IndustriesPage";
import ServicesPage from "@/pages/ServicesPage";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SeoManager />
        <ScrollToTop />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route index element={<HomePage />} path="/" />
            <Route element={<ServicesPage />} path="/services" />
            <Route element={<ClientsPage />} path="/clients" />
            <Route element={<IndustriesPage />} path="/industries" />
            <Route element={<AboutPage />} path="/who-we-are" />
            <Route element={<AboutPage />} path="/about" />
            <Route element={<ContactPage />} path="/contact" />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
